import * as React from 'react';
import Orders from './orders';


export const zeroPad = (num, places) => String(num).padStart(places, '0');




export const MyWaitingOrders = () => {

    return (
        <>
        <Orders theData={{ justPreStates: true, pageTitle : "فهرست سفارش های در انتظار تایید"  }} />
</>
    );
}
export default MyWaitingOrders;